import _ from 'lodash'
import {WPHOTO_CUSTOM_DESIGN_TYPE} from '../../../decorations/wphoto/constants'
import {IMAGEX_CUSTOM_DESIGN_TYPE} from '../../../decorations/imagex/constants'

type CssMap = Record<string, Record<string, Record<string, string>>>

export const SCHEMA_PATH_TO_CSS_PROPERTIES: CssMap = {
    layout: {
        SingleLayoutData: {
            'componentLayout.containerType': 'container-type',
            'componentLayout.width': 'width',
            'componentLayout.height': 'height',
            'componentLayout.minWidth': 'min-width',
            'componentLayout.minHeight': 'min-height',
            'componentLayout.maxWidth': 'max-width',
            'componentLayout.maxHeight': 'max-height',
            'componentLayout.margins.top': 'margin-top',
            'componentLayout.margins.bottom': 'margin-bottom',
            'componentLayout.margins.left': 'margin-left',
            'componentLayout.margins.right': 'margin-right',
            'componentLayout.direction': 'direction',
            'componentLayout.rotationInDegrees': 'rotate',
            'componentLayout.fixed': 'fixed',
            'componentLayout.hidden': 'hidden',
            'componentLayout.type': 'component-layout',
            'itemLayout.type': 'item-layout',
            'itemLayout.scrollSnapAlign': 'scroll-snap-align',
            'itemLayout.pinnedToContainer': 'pinned-to-container',
            'itemLayout.margins.top': 'item-margin-top',
            'itemLayout.margins.bottom': 'item-margin-bottom',
            'itemLayout.margins.left': 'item-margin-left',
            'itemLayout.margins.right': 'item-margin-right',
            'itemLayout.position': 'position',
            'itemLayout.top': 'top',
            'itemLayout.bottom': 'bottom',
            'itemLayout.left': 'left',
            'itemLayout.right': 'right',
            'itemLayout.gridArea.rowStart': 'grid-row-start',
            'itemLayout.gridArea.columnStart': 'grid-column-start',
            'itemLayout.gridArea.rowEnd': 'grid-row-end',
            'itemLayout.gridArea.columnEnd': 'grid-column-end',
            'itemLayout.alignSelf': 'align-self',
            'itemLayout.justifySelf': 'justify-self',
            'itemLayout.order': 'order',
            'itemLayout.basis': 'flex-basis',
            'itemLayout.grow': 'flex-grow',
            'itemLayout.shrink': 'flex-shrink',
            'containerLayout.rows': 'grid-template-rows',
            'containerLayout.columns': 'grid-template-columns',
            'containerLayout.rowGap': 'row-gap',
            'containerLayout.columnGap': 'column-gap',
            'containerLayout.autoRows': 'grid-auto-rows',
            'containerLayout.autoColumns': 'grid-auto-columns',
            'containerLayout.autoFlow': 'grid-auto-flow',
            'containerLayout.overflowY': 'overflow-y',
            'containerLayout.overflowX': 'overflow-x',
            'containerLayout.hideScrollbar': 'hide-scroll-bar',
            'containerLayout.padding.top': 'padding-top',
            'containerLayout.padding.bottom': 'padding-bottom',
            'containerLayout.padding.left': 'padding-left',
            'containerLayout.padding.right': 'padding-right',
            'containerLayout.scrollSnap.scrollSnapType': 'scroll-snap-type',
            'containerLayout.scrollSnap.scrollSnapDirection': 'scroll-snap-direction',
            'containerLayout.scrollBehavior': 'scroll-behavior',
            'containerLayout.type': 'container-layout',
            'containerLayout.contain': 'contain',
            'containerLayout.scrollSnapAlign': 'container-scroll-snap-align',
            'containerLayout.pinnedToContainer': 'container-pinned-to-container',
            'containerLayout.margins.top': 'container-margin-top',
            'containerLayout.margins.bottom': 'container-margin-bottom',
            'containerLayout.margins.left': 'container-margin-left',
            'containerLayout.margins.right': 'container-margin-right',
            'containerLayout.position': 'container-position',
            'containerLayout.top': 'container-top',
            'containerLayout.bottom': 'container-bottom',
            'containerLayout.left': 'container-left',
            'containerLayout.right': 'container-right',
            'containerLayout.direction': 'flex-direction',
            'containerLayout.wrap': 'flex-wrap',
            'containerLayout.alignItems': 'align-items',
            'containerLayout.justifyContent': 'justify-content',
            'containerLayout.scrollBehaviour': 'container-scroll-behavior',
            'containerLayout.contentMaxWidth.maxWidth': 'content-max-width',
            'containerLayout.contentMaxWidth.align': 'content-max-width-align',
            'containerLayout.layoutIntent': 'layout-intent',
            type: 'layout-type'
        }
    },
    design: {
        [WPHOTO_CUSTOM_DESIGN_TYPE]: {
            crop: 'crop',
            cropMask: 'crop-mask',
            focalPoint: 'focal-point',
            type: 'design-type'
        },
        [IMAGEX_CUSTOM_DESIGN_TYPE]: {
            crop: 'crop',
            cropMask: 'crop-mask',
            focalPoint: 'focal-point',
            scrollEffect: 'scroll-effect',
            type: 'design-type'
        },
        MediaContainerDesignData: {
            charas: 'charas',
            'background.mediaRef': 'background-media-ref',
            'background.mediaTransforms.scale': 'background-media-transform-scale',
            'background.mediaTransforms.opacity': 'background-media-transform-opacity',
            'background.overlayTransforms.scale': 'background-overlay-transform-scale',
            'background.overlayTransforms.opacity': 'background-overlay-transform-opacity',
            'background.color': 'design-background-color',
            'background.colorOpacity': 'background-color-opacity',
            'background.alignType': 'background-align-type',
            'background.fittingType': 'background-fitting-type',
            'background.scrollType': 'background-scroll-type',
            'background.showOverlayForMediaType': 'background-show-overlay-for-media-type',
            'background.imageOverlay': 'background-image-overlay',
            'background.colorOverlay': 'background-color-overlay',
            'background.colorOverlayOpacity': 'background-color-overlay-opacity',
            'background.overlayBlending.color': 'background-overlay-blending-color',
            'background.overlayBlending.opacity': 'background-overlay-blending-opacity',
            'background.overlayBlending.contrast': 'background-overlay-blending-contrast',
            'background.overlayBlending.saturate': 'background-overlay-blending-saturate',
            'background.overlayBlending.blendMode': 'background-overlay-blending-blendMode',
            'background.filterEffect.effectType': 'background-filter-effect-effect-type',
            'background.filterEffect.brightness': 'background-filter-effect-brightness',
            'background.filterEffect.contrast': 'background-filter-effect-contrast',
            'background.filterEffect.saturation': 'background-filter-effect-saturation',
            'background.filterEffect.hue': 'background-filter-effect-hue',
            'background.filterEffect.duotoneDark': 'background-filter-effect-duotone-dark',
            'background.filterEffect.duotoneLight': 'background-filter-effect-duotone-light',
            'background.filterEffect.invert': 'background-filter-effect-invert',
            'background.filterEffect.isCustom': 'background-filter-effect-is-custom',
            'background.colorLayers': 'background-color-layers',
            dataChangeBehaviors: 'dataChangeBehaviors',
            'cssStyle.cssBorder.width.top': 'border-top-width',
            'cssStyle.cssBorder.width.right': 'border-right-width',
            'cssStyle.cssBorder.width.bottom': 'border-bottom-width',
            'cssStyle.cssBorder.width.left': 'border-left-width',
            'cssStyle.cssBorder.style.top': 'border-top-style',
            'cssStyle.cssBorder.style.right': 'border-right-style',
            'cssStyle.cssBorder.style.bottom': 'border-bottom-style',
            'cssStyle.cssBorder.style.left': 'border-left-style',
            'cssStyle.cssBorder.color.top': 'border-top-color',
            'cssStyle.cssBorder.color.right': 'border-right-color',
            'cssStyle.cssBorder.color.bottom': 'border-bottom-color',
            'cssStyle.cssBorder.color.left': 'border-left-color',
            'cssStyle.cssBoxShadow': 'design-box-shadow',
            'cssStyle.cssBorderRadius.topLeft': 'border-top-left-radius',
            'cssStyle.cssBorderRadius.topRight': 'border-top-right-radius',
            'cssStyle.cssBorderRadius.bottomLeft': 'border-bottom-left-radius',
            'cssStyle.cssBorderRadius.bottomRight': 'border-bottom-right-radius',
            type: 'design-type'
        },
        MediaPlayerDesignData: {
            charas: 'charas',
            'background.mediaRef': 'background-media-ref',
            'background.mediaTransforms.scale': 'background-media-transform-scale',
            'background.mediaTransforms.opacity': 'background-media-transform-opacity',
            'background.overlayTransforms.scale': 'background-overlay-transform-scale',
            'background.overlayTransforms.opacity': 'background-overlay-transform-opacity',
            'background.color': 'design-background-color',
            'background.colorOpacity': 'background-color-opacity',
            'background.alignType': 'background-align-type',
            'background.fittingType': 'background-fitting-type',
            'background.scrollType': 'background-scroll-type',
            'background.showOverlayForMediaType': 'background-show-overlay-for-media-type',
            'background.imageOverlay': 'background-image-overlay',
            'background.colorOverlay': 'background-color-overlay',
            'background.colorOverlayOpacity': 'background-color-overlay-opacity',
            'background.overlayBlending.color': 'background-overlay-blending-color',
            'background.overlayBlending.opacity': 'background-overlay-blending-opacity',
            'background.overlayBlending.contrast': 'background-overlay-blending-contrast',
            'background.overlayBlending.saturate': 'background-overlay-blending-saturate',
            'background.overlayBlending.blendMode': 'background-overlay-blending-blendMode',
            'background.filterEffect.effectType': 'background-filter-effect-effect-type',
            'background.filterEffect.brightness': 'background-filter-effect-brightness',
            'background.filterEffect.contrast': 'background-filter-effect-contrast',
            'background.filterEffect.saturation': 'background-filter-effect-saturation',
            'background.filterEffect.hue': 'background-filter-effect-hue',
            'background.filterEffect.duotoneDark': 'background-filter-effect-duotone-dark',
            'background.filterEffect.duotoneLight': 'background-filter-effect-duotone-light',
            'background.filterEffect.invert': 'background-filter-effect-invert',
            'background.filterEffect.isCustom': 'background-filter-effect-is-custom',
            'background.colorLayers': 'background-color-layers',
            'cssStyle.cssBorder.width.top': 'border-top-width',
            'cssStyle.cssBorder.width.right': 'border-right-width',
            'cssStyle.cssBorder.width.bottom': 'border-bottom-width',
            'cssStyle.cssBorder.width.left': 'border-left-width',
            'cssStyle.cssBorder.style.top': 'border-top-style',
            'cssStyle.cssBorder.style.right': 'border-right-style',
            'cssStyle.cssBorder.style.bottom': 'border-bottom-style',
            'cssStyle.cssBorder.style.left': 'border-left-style',
            'cssStyle.cssBorder.color.top': 'border-top-color',
            'cssStyle.cssBorder.color.right': 'border-right-color',
            'cssStyle.cssBorder.color.bottom': 'border-bottom-color',
            'cssStyle.cssBorder.color.left': 'border-left-color',
            'cssStyle.cssBoxShadow': 'design-box-shadow',
            'cssStyle.cssBorderRadius.topLeft': 'border-top-left-radius',
            'cssStyle.cssBorderRadius.topRight': 'border-top-right-radius',
            'cssStyle.cssBorderRadius.bottomLeft': 'border-bottom-left-radius',
            'cssStyle.cssBorderRadius.bottomRight': 'border-bottom-right-radius',
            type: 'design-type'
        },
        VectorImageDesignData: {
            'shapeStyle.opacity': 'opacity',
            'shapeStyle.stroke': 'stroke',
            'overrideColors.color1': 'override-color1',
            'overrideColors.color2': 'override-color2',
            'overrideColors.color3': 'override-color3',
            'overrideColors.color4': 'override-color4',
            'overrideColors.color5': 'override-color5',
            'overrideColors.color6': 'override-color6',
            'overrideColors.color7': 'override-color7',
            'overrideColors.color8': 'override-color8',
            shadow: 'drop-shadow',
            type: 'design-type'
        }
    },
    style: {
        TopLevelStyle: {
            skin: 'skin',
            styleType: 'style-subtype',
            pageId: 'page-id',
            compId: 'comp-id',
            componentClassName: 'class-name',
            type: 'style-type'
        },
        ComponentStyle: {
            skin: 'skin',
            styleType: 'style-subtype',
            pageId: 'page-id',
            compId: 'comp-id',
            componentClassName: 'class-name',
            'spx.refWidth': 'spx-ref-width',
            'spx.resolverType': 'spx-resolver-type',
            'themeOverrides.spx.refWidth': 'theme-overrides-spx-ref-width',
            'themeOverrides.spx.resolverType': 'theme-overrides-spx-resolver-type',
            'style.properties.bg': 'background',
            'style.properties.rd': 'border-radius',
            'style.properties.txt': 'text',
            'style.properties.brd': 'border-color',
            'style.properties.brdh': 'border-color-hover',
            'style.properties.shd': 'box-shadow',
            'style.properties.brw': 'border-width',
            'style.properties.tdr': 'theme-directory',
            'style.properties.fnt': 'font',
            'style.properties.bgh': 'background-color-hover',
            'style.properties.txth': 'text-hover',
            'style.properties.trans': 'transition',
            'style.properties.textDecoration': 'text-decoration',
            'style.properties.textAlign': 'text-align',
            'style.properties.fontFamily': 'font-family',
            'style.properties.fontSize': 'font-size',
            'style.properties.maxFontSize': 'max-font-size',
            'style.properties.minFontSize': 'min-font-size',
            'style.properties.color': 'color',
            'style.properties.fontWeight': 'font-weight',
            'style.properties.fontStyle': 'font-style',
            'style.properties.backgroundColor': 'background-color',
            'style.properties.lineHeight': 'line-height',
            'style.properties.letterSpacing': 'letter-spacing',
            'style.properties.align': 'align',
            'style.properties.margin': 'margin',
            'style.properties.horizontalPadding': 'padding-horizontal',
            'style.properties.verticalPadding': 'padding-vertical',
            type: 'style-type'
        }
    }
}

export const CSS_PROPERTIES_TO_SCHEMA_PATH: CssMap = _.mapValues(SCHEMA_PATH_TO_CSS_PROPERTIES, namespace =>
    _.mapValues(namespace, dataNode => _.invert(dataNode))
)

export const DEFAULT_SERIALIZER_TYPE = 'Unknown'
